import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core'
import { OccConfig } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { Subscription } from 'rxjs'
import { CreditClaim } from '../../../../models/credit-claims.model'
import { ICustomMedia } from '../../../../models/interface/media.interface'

@Component({
  selector: 'app-credit-claim-attachments-modal',
  templateUrl: './credit-claim-attachments-modal.component.html',
  styleUrls: ['./credit-claim-attachments-modal.component.scss'],
  standalone: false
})
export class CreditClaimAttachmentsModalComponent implements OnInit, AfterViewInit, OnDestroy {
  public data: CreditClaim
  public selectedImage: ICustomMedia
  public selectedImageIndex: number
  @ViewChildren('thumbnail', {}) imageList: QueryList<ElementRef>
  private images: ElementRef[]

  private subscription: Subscription = new Subscription()

  constructor(
    public occConfig: OccConfig,
    public launchDialogService: LaunchDialogService
  ) {}

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  ngOnInit(): void {
    this.subscription.add(
      this.launchDialogService.data$.subscribe((res) => {
        this.data = res
        this.showImagePreview(this.data?.images[0], 0)
      })
    )
  }

  ngAfterViewInit(): void {
    this.images = this.imageList.toArray()
  }

  public dismissModal(): void {
    this.launchDialogService.closeDialog('close')
  }

  public getImageUrl(image: ICustomMedia): string {
    return this.occConfig.backend.occ.baseUrl + image.url
  }

  public showImagePreview(image: ICustomMedia, i: number): void {
    this.selectedImageIndex = i
    this.selectedImage = {
      ...image,
      url: this.getImageUrl(image)
    }
  }

  public previousImage(): void {
    if (this.selectedImageIndex - 1 >= 0) {
      const index = this.selectedImageIndex - 1
      this.showImagePreview(this.data.images[index], index)
      this.images[index].nativeElement.scrollIntoView({ behavior: 'smooth' })
    }
  }

  public nextImage(): void {
    if (this.selectedImageIndex + 1 <= this.data.images.length - 1) {
      const index = this.selectedImageIndex + 1
      this.showImagePreview(this.data.images[index], index)
      this.images[index].nativeElement.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
